<template>
	<div class="container-fluid">
		<nav-header :key="$route.fullPath" :navItems="[
			{
				name: 'Configuration',
				link: {
					name: 'Sandbox Job Configuration',
					params: {
						sandboxId: `${selectedSandbox}`,
						jobId: `${$route.params.jobId}`,
					},
				},
			},
			{
				name: 'Meters',
				link: {
					name: 'Sandbox Job Meters',
					params: {
						sandboxId: `${selectedSandbox}`,
						jobId: `${$route.params.jobId}`,
					},
				},
				disable: !showMetersTab,
			},
			{
				name: 'Parameters',
				link: {
					name: 'Sandbox Job Parameters',
					params: {
						sandboxId: `${selectedSandbox}`,
						jobId: `${$route.params.jobId}`,
					},
				},
				disable: !showParametersTab,
			},
			{
				name: 'Override',
				link: {
					name: 'Sandbox Job Override',
					params: {
						sandboxId: `${selectedSandbox}`,
						jobId: `${$route.params.jobId}`,
					},
				},
				disable: !showOverrideTab,
			},
			{
				name: 'Run History',
				link: {
					name: 'Sandbox Job Run History',
					params: {
						sandboxId: `${selectedSandbox}`,
						jobId: `${$route.params.jobId}`,
					},
				},
			},
			{
				name: `${$route.params.executionId}`,
				link: {
					name: 'Sandbox Job Execution Details',
					params: {
						sandboxId: `${selectedSandbox}`,
						jobId: `${$route.params.jobId}`,
						executionId: ` `,
					},
				},
				closeTab: true,
				disable: true,
			},
			{
				name: 'Promotions',
				link: {
					name: 'Sandbox Job Promotions',
					params: {
						sandboxId: `${selectedSandbox}`,
						jobId: `${$route.params.jobId}`,
					},
				},
				disable: !hasProdV2Sandbox(),
			}

		]" pretitle="Job" :breadcrumbTitle="true" @nav-close-clicked="closeNav">
			<template v-slot:breadcrumb-title>
				<nav aria-label="breadcrumb" class="header-title">
					<ol class="breadcrumb">
						<li class="breadcrumb-item">
							<a @click="closeClick" href="#" class="h1">{{
								selectedSandbox
							}}</a>
						</li>
						<li class="breadcrumb-item active h1" aria-current="page">
							{{ $route.params.jobId }}
						</li>
					</ol>
				</nav>
			</template>
			<template v-slot:header-button-content>
				<div class="custom-btn-group">
					<span v-if="editMode && !hideSaveBtn">
						<button @click.prevent="onSaveClick()" class="btn btn-success" :disabled="isButtonDisabled">
							<i v-if="isButtonDisabled" class="fa fa-circle-exclamation" title="Please fix lint errors"
								data-bs-toggle="tooltip" data-bs-placement="left"></i>
							Save</button>
						<button @click.prevent="onSaveAndRunClick()" class="btn btn-success"
							:disabled="isButtonDisabled">
							<i v-if="isButtonDisabled" class="fa fa-circle-exclamation" title="Please fix lint errors"
								data-bs-toggle="tooltip" data-bs-placement="left"></i>
							Save & Run
						</button>
						<button @click.prevent="onDeleteClick()" class="btn btn-danger">
							Delete</button>
						<button @click.prevent="onCancelClick()" class="btn btn-secondary">
							Cancel</button>
					</span>
					<span v-else-if="!editMode && !hideEditBtn">
						<button type="button" @click.prevent="onEditClick()" class="btn btn-primary">
							Edit</button>
					</span>
					<span v-else-if="isOverrideAccessible && overrideEditMode && !showOverrideEdit">
						<button @click.prevent="setSaveOverride()" class="btn btn-success" :disabled="isButtonDisabled">
							<i v-if="isButtonDisabled" class="fa fa-circle-exclamation" title="Please fix lint errors"
								data-bs-toggle="tooltip" data-bs-placement="left"></i>
							Save Override</button>
						<button v-if="isAccessByUserRole(editDeleteOverrideRoles)"
							@click.prevent="onOverrideDeleteClick()" class="btn btn-danger">
							Delete</button>
						<button @click.prevent="onOverrideCancelClick()" class="btn btn-secondary">
							Cancel</button>
					</span>
					<span v-else-if="isOverrideAccessible && !overrideEditMode && showOverrideEdit">
						<button type="button" @click.prevent="onOverrideEditClick()" class="btn btn-primary">
							Edit</button>
					</span>
					<button v-if="!editMode && !hideRunJobBtn" @click="btnClick" class="btn btn-primary"
						:disabled="isButtonDisabled">
						<div v-if="runClicked" class="spinner-border spinner-border-sm" role="status">
							<span class="visually-hidden">Loading...</span>
						</div>
						<div v-else>
							<slot></slot>
							<i v-if="isButtonDisabled" class="fa fa-circle-exclamation" title="Please fix lint errors"
								data-bs-toggle="tooltip" data-bs-placement="right"></i>
							Run Job
						</div>
					</button>
					<div class="input-group" v-if="isAccessByUserRole(reRunJobRoles) && !hideReRunJobBtn"
						style="width: auto; margin-right: 12px;">
						<button @click.prevent="reRunJobClick" :disabled="reRunning" class="btn btn-info"
							:class="[reRunning ? 'rerunning-btn' : 'rerun-btn']">
							<div v-if="reRunning" class="spinner-border spinner-border-sm me-1" role="status">
								<span class="visually-hidden">Loading...</span>
							</div>
							Rerun Job
							<i class="fa fa-circle-info ms-1"
								title="Rerun a failed/cancelled job execution. For custom image, use <strong>Rerun with Image</strong> option."
								data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-html="true"></i>
						</button>
						<div class="d-flex align-items-center custom-dropdown">
							<ActionDropdown :btnList="rerunBtnList" :icon="['fa', 'fa-caret-down', 'px-1']"
								:iconStyle="{ color: '#ffffff', fontSize: '17px' }" />
						</div>
					</div>
					<button
						v-if="!hidePromoteBtn && hasProdV2Sandbox() && isAccessByUserRole(promoteJobRoles) && latestSuccessfulJobRun"
						@click.prevent="onPromoteClick()" class="btn btn-primary">
						{{ promoteBtnLabel }}</button>
					<button v-if="showCancelJobBtn" class="btn btn-secondary" @click="setCancelJob">
						<div v-if="runClicked" class="spinner-border spinner-border-sm" role="status">
							<span class="visually-hidden">Loading...</span>
						</div>
						<div v-else>
							<slot></slot>Cancel Job
						</div>
					</button>
					<button @click="closeClick" class="btn btn-secondary lift">
						<i class="fa fa-arrow-left me-1"></i> Back to {{ isPipelineJob ? "Pipelines" : "Jobs" }} list
					</button>
					<ActionDropdown :btnList="btnList" />
				</div>
			</template>
		</nav-header>

		<div>
			<router-view v-if="job" :key="$route.fullPath" :editMode="editMode" :overrideEditMode="overrideEditMode"
				:isSandbox="true" :job="job" :showEnvParamOptions="showParametersTab" :override="override"
				:meters="meters" :runJobTrigger="runJobTrigger" :saveJobTrigger="saveJobTrigger"
				:saveAndJobTrigger="saveAndJobTrigger" :cancelJobTrigger="cancelJobTrigger" :copyCurl="copyCurl"
				:snapshot="snapshot" :snapOverride="snapOverride" :saveJobConfigTrigger="saveJobConfigTrigger"
				:saveJobOverrideTrigger="saveJobOverrideTrigger" :reRunJobTrigger="reRunJobTrigger"
				:reRunJobTriggerWithImage="reRunJobTriggerWithImage" v-on:setRunClick="setRunClick" :pipelineJobs="underlyingPipelineJobs"
				v-on:onLintFailure="setRunJobBtnState" v-on:triggerEditMode="setEditMode" v-on:hideEdit="setHideEdit"
				v-on:hideSaveBtn="setHideSave" v-on:hidePromoteBtn="setHidePromoteBtn" v-on:hideRunJob="setHideRunJob"
				v-on:showOverrideEdit="setShowOverrideEdit" v-on:setOverrideEditMode="setOverrideEditMode"
				v-on:showCancelJob="setShowCancelJob" v-on:setSnapshot="setSnapshot"
				v-on:setSnapOverride="setSnapOverride" v-on:setSaveConfigBtn="setSaveConfigBtn"
				v-on:hideReRunJobBtn="setHideReRunJobBtn" v-on:reRunning="setReRunning"></router-view>
		</div>

	</div>
</template>

<script>
import NavHeader from "../../components/NavHeader.vue";
import { mapState, mapActions } from "vuex";
import ActionDropdown from "../../components/ActionDropdown.vue";
import YAML from "yaml";
export default {
	name: "SandboxJobDetail",
	components: { NavHeader, ActionDropdown },
	data() {
		return {
			runJobTrigger: false,
			saveJobTrigger: false,
			cancelJobTrigger: false,
			saveAndJobTrigger: false,
			job: null,
			override: null,
			meters: null,
			selectedSandbox: this.$route.params.sandboxId,
			snapshot: null,
			snapOverride: null,
			error: "",
			successMessage: "",
			configFile: null,
			varsFile: null,
			runClicked: false,
			isButtonDisabled: false,
			editMode: false,
			overrideEditMode: false,
			cancelJob: false,
			hideSaveBtn: false,
			hideEditBtn: false,
			hideRunJobBtn: false,
			showOverrideEdit: false,
			showCancelJobBtn: false,
			hidePromoteBtn: false,
			showSaveConfigBtn: false,
			saveJobConfigTrigger: false,
			saveJobOverrideTrigger: false,
			sandboxJobs: this.$store.state.sandbox.sandboxJobs,
			navigate: this.$router,
			copyCurl: false,
			promoteJobRoles: [1, 1.5, 2, 3, 4],
			showOverrideTab: false,
			showMetersTab: false,
			editDeleteOverrideRoles: [1, 1.5],
			showParametersTab: false,

			reRunning: false,
			hideReRunJobBtn: true,
			reRunJobTrigger: false,
			reRunJobTriggerWithImage: false,
			reRunJobRoles: [1, 1.5, 3],

			// pipeline jobs info
			underlyingPipelineJobs: [],
		};
	},
	computed: {
		...mapState({
			latestSuccessfulJobRun: (state) =>
				state.sandbox.latestSuccessfulJobRun,
		}),
		isOverrideAccessible() {
			const sandbox = this.$store.state.sandbox.devSandboxes.find(sandbox => sandbox.name === this.$store.state.sandbox.currentSandbox);
			console.log("sandbox", sandbox);
			if (sandbox?.override_access_expires_after) {
				const overrideExpiresAfter = new Date(sandbox.override_access_expires_after);
				const currentDate = new Date();

				// check if override expires after current date and user has aqfer_admin or aqfer_user role
				return overrideExpiresAfter > currentDate && this.isAccessByUserRole([1, 2]);
			}
			return this.isAccessByUserRole(this.editDeleteOverrideRoles);
		},
		btnList() {
			return [
				{
					id: 1,
					name: 'Add Override',
					visible: !this.showOverrideTab && this.isOverrideAccessible,
					onClick: () => this.onAddOverride(),
					icon: 'fa fa-plus',
				},
				{
					id: 2,
					name: 'Clone Job',
					visible: !this.editMode && !this.hideRunJobBtn && this.$route.params.jobId,
					onClick: () => this.onCloneJob(),
					icon: 'fa fa-clone',
				},
				{
					id: 3,
					name: 'cURL Command',
					visible: !this.editMode && !this.hideRunJobBtn && this.$route.params.jobId,
					onClick: () => this.copyCurlClick(),
					icon: 'fa fa-code',
				},
				{
					id: 4,
					name: 'Save as Current Config',
					visible: this.showSaveConfigBtn,
					onClick: () => this.setSaveJobConfig(),
					icon: 'fa fa-save',
				},
				{
					id: 5,
					name: 'Validate Config',
					visible: !this.editMode && !this.hideRunJobBtn && this.$route.params.jobId && this.configFile,
					onClick: () => this.validateJobConfiguration(),
					icon: 'fa fa-check',
				},
			]
		},
		rerunBtnList() {
			return [
				{
					id: 1,
					name: 'Rerun with Image',
					visible: !this.reRunning,
					onClick: () => this.reRunJobClickWithImage(),
					icon: 'fa-brands fa-docker',
				}
			]
		},
		promoteBtnLabel() {
			return (this.$route.params.executionId) ? "Promote Job Run" : "Promote Job";
		},
		isPipelineJob() {
			return this.job?.kind?.toLowerCase() === "pipeline";
		}
	},
	beforeMount() {
		this.fetchSandboxJob();
	},
	methods: {
		...mapActions({
			readSandboxJob: "sandbox/readSandboxJob",
			readOverrideFile: "sandbox/readOverrideFile",
			deleteSandboxJob: "sandbox/deleteSandboxJob",
			deleteOverrideFile: "sandbox/deleteOverrideFile",
			updateOverrideFile: "sandbox/updateOverrideFile",
			fetchParameters: "amdp/fetchLakeviewParameters",
			validateJobConfig: "sandbox/validateJobConfig",
			showModal: "showModal",
		}),
		async fetchSandboxJob() {
			let self = this;
			this.configFile = this.varsFile = null; // set to null before fetching job
			let response;
			try {
				response = await this.readSandboxJob(
					this.$route.params.jobId
				);
				this.job = await response.data;
				this.configFile = this.job.system_files.find((file) => file.relative_path === "config.yaml");
				this.varsFile = this.job.system_files.find((file) => file.relative_path === "vars.yaml");
				this.checkParameters();
				if (this.job.meters) {
					this.meters = this.job.meters
					this.showMetersTab = true;
				} else {
					this.meters = null;
					this.showMetersTab = false;
				}
				this.snapshot = JSON.parse(JSON.stringify(this.job)); // deep clone
				self.$store.dispatch("sandbox/fetchSandboxJobRuns", { jobName: self.job.name, limit: this.$store.state.sandbox.executionsListLimit });
			} catch (error) {
				if (error.response.data.error)
					this.error = error.response.data.error;
				else this.error = error.message;
			} finally {
				this.fetchOverrideFile()
				await this.fetchUnderlyingPipelineJobs(); // if pipeline job, fetch the underlying pipeline jobs info for UI visualization
			}
		},
		async fetchUnderlyingPipelineJobs() {
			if (this.job?.kind?.toLowerCase() === "pipeline") {
				if (!this.job.system_files) return null;
				const configFile = this.job.system_files.find(
					f => f.relative_path === 'config.yaml'
				);
				const varsFile = this.job.system_files.find(
					f => f.relative_path === 'vars.yaml'
				);
				if (!configFile?.content) return null;

				let jobsInfo = [];
				try {
					// merging is required, since the config file may refer anchors defined in vars file.
					// yaml parser does not support a case where anchors are used but not defined.
					const mergedFile = (varsFile?.content || '') + '\n' + (configFile?.content || '');
					const parsed = YAML.parse(mergedFile);

					const jobNames = this.getJobNames(parsed);
					const readPromises = jobNames.map(async (jobName) => {
						return this.readSandboxJob(jobName).then(response => {
							jobsInfo.push({jobDetails: response.data});
						});
					});
					const results = await Promise.allSettled(readPromises);
				} catch (e) {
					console.error('YAML parse error', e);
				} finally {
					this.underlyingPipelineJobs = [...jobsInfo];
				}
			}
		},
		getJobNames(input, names = []) {
			if (input.in_sequence) {
				input.in_sequence.forEach(item => this.getJobNames(item, names));
			} else if (input.in_parallel) {
				input.in_parallel.forEach(item => this.getJobNames(item, names));
			} else if (input.job_name) {
				names.push(input.job_name);
			}
			return names;
		},
		async fetchOverrideFile() {
			let response;
			try {
				response = await this.readOverrideFile(
					this.$route.params.jobId
				);
				this.override = await response.data;
				if (this.override) {
					this.showOverrideTab = true;
					this.snapOverride = JSON.parse(JSON.stringify(this.override));
				}
				else
					this.showOverrideTab = false;

			} catch (error) {
				this.showOverrideTab = false;
				if (error.response.data.error)
					this.error = error.response.data.error;
				else this.error = error.message;
			}

		},
		async checkParameters() {
			try {
				this.setParametersTab(false);
				for (const file of this.job.system_files) {
					if (file.relative_path === "vars.yaml") {
						const documents = YAML.parseAllDocuments(file.content);
						if (!documents.length) return;

						const root = documents[0].toJS();
						if (root && typeof root === 'object' && 'parameters' in root) {
							await this.fetchParameters({
								sandboxName: `${this.$route.params.sandboxId}`,
								jobName: `${this.$route.params.jobId}`,
							});
							this.setParametersTab(true);
						}
					}
				}
			} catch (e) {
				console.error('YAML parsing error: ', e);
			}
		},
		setEditMode(mode) {
			this.editMode = mode;
			this.successMessage = null;
			this.error = null;
		},
		setOverrideEditMode(mode) {
			this.overrideEditMode = mode;
			this.successMessage = null;
			this.error = null;
		},
		onDeleteClick() {
			const self = this;
			this.showModal({
				component: "confirm",
				data: {
					title: "Delete Sandbox",
					message: `Are you sure you want to delete ${this.job.name}?`,
					async confirm() {
						try {
							const response = await self.deleteSandboxJob(
								self.job.name
							);
							self.$store.dispatch("hideModal");
							self.$router.push({
								name: this.isPipelineJob ? "Sandbox Pipelines" : "Sandbox Jobs",
								params: {
									sandboxId: `${self.$route.params.sandboxId}`,
								},
							});
							return response;
						} catch (error) {
							if (error.response && error.response.data.error)
								self.error = error.response.data.error;
							else self.error = error.message;
							return;
						}
					},
				},
			});
		},
		onOverrideDeleteClick() {
			const self = this;
			let toastoptions = "";
			this.showModal({
				component: "confirm",
				data: {
					title: "Delete Override",
					message: `Are you sure you want to delete override.yaml?`,
					async confirm() {
						try {
							const response = await self.deleteOverrideFile(
								self.job.name
							);
							self.$store.dispatch("hideModal");
							self.setSnapOverride({});
							self.showOverrideTab = false;
							self.override = null;
							toastoptions = {
								message: "Override file deleted successfully.",
								type: "success"
							}
							self.$router.push({
								name: "Sandbox Job Configuration",
								params: {
									sandboxId: `${self.$route.params.sandboxId}`,
								},
							});
						} catch (error) {
							if (error.response.data.error)
								this.error = error.response.data.error
							else
								this.error = error.message
							toastoptions = {
								message: this.error || "Error in deleting override file.",
								type: "error"
							}
							self.onOverrideCancelClick();
						}
						self.$store.dispatch('addToast', toastoptions);
					},
				},
			});
		},
		onEditClick() {
			this.setEditMode(true);
		},
		onOverrideEditClick() {
			this.setOverrideEditMode(true);
			this.setShowOverrideEdit(false);
		},
		onOverrideCancelClick() {
			this.override = { ...this.snapOverride };
			this.setOverrideEditMode(false);
			this.setShowOverrideEdit(true);
		},
		onCancelClick() {
			this.job = { ...this.snapshot };
			this.setEditMode(false);
		},
		btnClick() {
			this.runClicked = true;
			this.runJobTrigger = !this.runJobTrigger;
		},
		copyCurlClick() {
			this.copyCurl = !this.copyCurl;
		},
		onSaveClick() {
			this.successMessage = null;
			this.error = null;
			this.saveJobTrigger = !this.saveJobTrigger;
		},
		onSaveAndRunClick() {
			this.saveAndJobTrigger = !this.saveAndJobTrigger;
		},
		setRunJobBtnState(btnState) {
			this.isButtonDisabled = btnState;
		},
		setRunClick(runClick) {
			this.runClicked = runClick;
		},
		onPromoteClick() {
			const dst_job_name = this.$store.state.sandbox.prodV2Sandboxes.length ? this.$store.state.sandbox.prodV2Sandboxes[0].name : "";
			let srcJobRunId = this.latestSuccessfulJobRun.id;
			const promoteObject = {
				dst_sandbox_name: dst_job_name,
				dst_job_name: this.job.name,
				description: "",
				vars: ""
			}
			//If promote job is triggered from job run details page
			if (this.$route.params.executionId) {
				srcJobRunId = this.$store.state.sandbox.successfulJobRunList.filter(jobRun => jobRun.execution_id === this.$route.params.executionId)[0].id;
				promoteObject.src_job_run_id = srcJobRunId;
			}
			this.showModal({ component: 'promoteJob', data: { promoteObject: promoteObject } });
		},
		setCancelJob() {
			this.cancelJobTrigger = !this.cancelJobTrigger;
		},
		setParametersTab(val) {
			// check if the current sandbox is a dev sandbox
			this.showParametersTab = val && this.$store.state.sandbox.devSandboxes.map(sandbox => { return sandbox.name })
				.includes(this.$store.state.sandbox.currentSandbox);
		},
		setHideEdit(hideEdit) {
			this.hideEditBtn = hideEdit;
		},
		setHideSave(hideSave) {
			this.hideSaveBtn = hideSave;
		},
		setHideRunJob(hideRunJob) {
			this.hideRunJobBtn = hideRunJob;
		},
		setShowOverrideEdit(showOverride) {
			this.showOverrideEdit = showOverride;
		},
		setHidePromoteBtn(hidePromote) {
			this.hidePromoteBtn = hidePromote;
		},
		hasProdV2Sandbox() {
			return this.$store.getters['sandbox/hasProdV2Sandbox']
		},
		setShowCancelJob(showCancelJob) {
			this.showCancelJobBtn = showCancelJob;
		},
		setSnapshot(job) {
			this.snapshot = job;
			this.onCancelClick();
			this.fetchSandboxJob();
		},
		setSnapOverride(override) {
			this.snapOverride = override;
			this.onOverrideCancelClick();
		},
		closeClick() {
			this.$router.push({
				name: this.isPipelineJob ? "Sandbox Pipelines" : "Sandbox Jobs",
				params: {
					sandboxId: `${this.$route.params.sandboxId}`,
				},
			});
		},
		closeNav(navName) {
			this.$router.push({
				name: "Sandbox Job Run History",
				params: {
					sandboxId: `${this.$route.params.sandboxId}`,
					jobId: `${this.$route.params.jobId}`,
				},
			});
		},
		isAccessByUserRole(roles) {
			return this.$store.getters.userRoles.isAccessByRole(roles);
		},
		setSaveJobConfig() {
			this.saveJobConfigTrigger = !this.saveJobConfigTrigger
		},
		setSaveOverride() {
			this.saveJobOverrideTrigger = !this.saveJobOverrideTrigger
		},
		setSaveConfigBtn(val) {
			this.showSaveConfigBtn = val
		},
		onCloneJob() {
			this.showModal({ component: "CloneSandboxJob", data: this.job });
		},
		onAddOverride() {
			var self = this;
			this.showModal({
				component: "AddOverride", data: {
					jobName: this.job.name,
					sandboxEnv: "DEV",
					fetchOverrideFile: () => this.fetchOverrideFile()
				}
			});
		},
		async validateJobConfiguration() {
			let toastOptions;
			let payload = {
				job_kind: this.job.kind,
				config: this.configFile.content
			}
			if (this.varsFile?.content) {
				payload["vars"] = this.varsFile.content;
			}
			await this.validateJobConfig(
				payload
			).then(response => {
				if (response.data?.validation_errors && response.data.validation_errors.length != 0) {
					this.showModal({
						component: "JobConfigValidation",
						data: {
							screenlarge: true,
							job: this.job,
							validationErrors: response.data.validation_errors
						}
					});
				} else {
					toastOptions = {
						message: "Job config validated successfully.",
						type: "success"
					}
				}
			}).catch(err => {
				let error = err.response ? err.response.data.error : err.message;
				toastOptions = {
					message: error || "Something went wrong while validating job configuration. Please contact support.",
					type: "error"
				}
			})
			if (toastOptions) this.$store.dispatch('addToast', toastOptions);
		},
		reRunJobClick() {
			this.reRunJobTrigger = !this.reRunJobTrigger;
		},
		reRunJobClickWithImage() {
			this.reRunJobTriggerWithImage = !this.reRunJobTriggerWithImage;
		},
		setHideReRunJobBtn(hideReRunJobBtn) {
			this.hideReRunJobBtn = hideReRunJobBtn;
		},
		setReRunning(reRunning) {
			this.reRunning = reRunning;
		},
	},
	watch: {
		'$store.state.sandbox.clonedFlag': {
			handler(newValue) {
				if (newValue) {
					this.fetchSandboxJob();
					this.$store.dispatch('sandbox/unsetClonedFlag')
				}
			},
			deep: true
		},
		'$store.state.sandbox.readJobTrigger': {
			handler(newValue) {
				this.fetchSandboxJob();
			},
			deep: true
		},
		'$route.params.jobId': {
			handler(newValue) {
				this.fetchSandboxJob();
			},
			deep: true
		}
	}
};
</script>

<style scoped>
.custom-btn-group {
	display: flex;
	align-items: center;
}

.btn {
	margin-right: 12px;
}

.custom-dropdown {
	background-color: #2a93b1;
	border-top-right-radius: 0.25rem;
	border-bottom-right-radius: 0.25rem;
}

.rerunning-btn {
	border-right: none !important;
	border-top-right-radius: 0.25rem !important;
	border-bottom-right-radius: 0.25rem !important;
}

.rerun-btn {
	margin-right: 0px !important;
	border-right: 1px solid #ffffff !important;
}
</style>
